// Opções do primeiro acesso e estimativa simples (só no front, sem promessa).
import { Globe, MessageCircle, Phone, Store, UserPlus, type LucideIcon } from 'lucide-react'
import type { Goal } from '@impulso/shared'

export const SEGMENTS = [
  'Software / SaaS', 'Loja virtual', 'Curso ou infoproduto', 'Serviços para empresas',
  'Restaurante', 'Confeitaria', 'Salão de beleza', 'Clínica', 'Loja de roupas', 'Pet shop', 'Academia', 'Serviços em casa', 'Outro',
]

/** Objetivo sugerido para ramos que não vivem de WhatsApp (o padrão). */
const SUGGESTED_GOAL: Record<string, Goal> = {
  'Software / SaaS': 'leads', 'Serviços para empresas': 'leads', 'Loja virtual': 'site', 'Curso ou infoproduto': 'site',
}
export const suggestedGoal = (segment: string): Goal => SUGGESTED_GOAL[segment] ?? 'whatsapp'

export const GOAL_OPTIONS: Array<{ id: Goal; icon: LucideIcon; title: string; hint: string; close: string; noun: string }> = [
  { id: 'whatsapp', icon: MessageCircle, title: 'Mais mensagens no WhatsApp', hint: 'Clientes chamando para pedir ou agendar', close: 'De cada 10 que chamam, quantos compram?', noun: 'contatos' },
  { id: 'site', icon: Globe, title: 'Mais vendas no site', hint: 'Compras ou assinaturas feitas direto pelo site', close: 'De cada 10 interessados, quantos compram?', noun: 'contatos' },
  { id: 'leads', icon: UserPlus, title: 'Mais cadastros', hint: 'Teste grátis, pedido de orçamento ou de demonstração', close: 'De cada 10 cadastros, quantos viram clientes?', noun: 'cadastros' },
  { id: 'store', icon: Store, title: 'Mais gente na loja', hint: 'Visitas ao endereço físico', close: 'De cada 10 que visitam, quantos compram?', noun: 'contatos' },
  { id: 'calls', icon: Phone, title: 'Mais ligações', hint: 'Telefone tocando', close: 'De cada 10 que ligam, quantos compram?', noun: 'contatos' },
]

export const TIMEZONES = [
  { id: 'America/Sao_Paulo', label: 'Brasília (SP, RJ, MG, Sul, NE…)' },
  { id: 'America/Manaus', label: 'Amazonas (AM, RR, RO, MT, MS)' },
  { id: 'America/Rio_Branco', label: 'Acre' },
  { id: 'America/Noronha', label: 'Fernando de Noronha' },
]

export const WEEKDAYS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

/** Faixa simples: R$ 10 a R$ 15 por contato (média de pequenos negócios). Mostrada como estimativa. */
export function estimate(budget: number, ticket: number, closePer10: number) {
  const low = Math.max(0, Math.round(budget / 15))
  const high = Math.max(0, Math.round(budget / 10))
  const rate = closePer10 / 10
  return { low, high, salesLow: Math.round(low * rate * ticket), salesHigh: Math.round(high * rate * ticket) }
}
